const INVOICE_STATUS_COLORS: { [key: string]: 'green' | 'red' | 'grey' } = {
  paid: 'green',
  unpaid: 'red',
  overdue: 'red',
  due: 'red',
};

export function getInvoiceStatusColor(value: string): 'green' | 'red' | 'grey' {
  if (!value) return 'grey';

  const normalizedValue = value.trim().toLowerCase();
  return INVOICE_STATUS_COLORS[normalizedValue] || 'grey';
}
